import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Text } from 'lusha-ui-components-v2';
import PropTypes from 'prop-types';
import React from 'react';
import './DescriptionInfo.scss';
function DescriptionInfo({ descriptionText }) {
    return (_jsx("div", { className: "error-description-container", children: _jsx("div", { className: "description-info-text", children: _jsx(Text, { variant: "smallR", children: descriptionText }) }) }));
}
export default DescriptionInfo;
DescriptionInfo.propTypes = {
    descriptionText: PropTypes.string,
};
